import { APP_COLORS } from "../../../constants/colors";

export const styles = {
  container: {
    justifyContent: "center",
    borderRadius: "5px",
    padding: "0rem 0.5rem",
    boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
    marginTop: "1rem",
  },
  calendarHeader: {
    flexDirection: "row",
    display: "flex",
    justifyContent: "center",
    gap: 20,
    alignItems: "center",
  },
  calendarHeaderData: {
    fontSize: 16,
    fontWeight: "600",
  },
  dateView: {
    borderRadius: 10,
    alignItems: "center",
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    width: 30,
    height: 30,
    fontSize: 12,
  },
  dates: {
    fontWeight: "500",
    textAlign: "center",
  },
  calendarDisplayRow: {
    display: "flex",
    alignItems: "center",
    paddingBottom: 15,
    justifyContent: "space-between",
    width: "100%",
  },
  calendarView: {
    alignItems: "center",
  },
  currentDateBackground: {
    backgroundColor: "#000000",
  },
  whiteText: {
    color: "#ffffff",
  },
  todaysDate: {
    borderBottomColor: "#000000",
    borderBottomWidth: 1.8,
    width: "85%",
    marginVertical: 6,
    borderStyle: "solid",
  },
  successDateBackground: {
    backgroundColor: APP_COLORS.successColor,
  },
  waringDateBackground: {
    backgroundColor: APP_COLORS.warningColor,
  },
  errorDateBackground: {
    backgroundColor: APP_COLORS.errorColor,
  },
  notSubmittedDateBackground: {
    backgroundColor: APP_COLORS.notSubmittedColor,
  },
  normalDateBackground: {
    backgroundColor: APP_COLORS.dateBackgroundColor,
  },
  noDateView: {
    width: 40,
    height: 40,
  },
};
